import { ProjectId } from "@taskin-code/contracts";
import { createFileRoute } from "@tanstack/react-router";

import { PullRequestsView } from "~/components/pullRequests/PullRequestsView";
import { parsePullRequestsRouteSearch } from "~/lib/pullRequestsRouteSearch";

function FocusedProjectPullRequestsRoute() {
  const { projectId } = Route.useParams();
  return <PullRequestsView fixedProjectId={ProjectId.makeUnsafe(projectId)} />;
}

export const Route = createFileRoute("/_chat/projects/$projectId/pull-requests")({
  validateSearch: (search) => parsePullRequestsRouteSearch(search),
  component: FocusedProjectPullRequestsRoute,
});
